import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { messages } from '../../header.messages';
import { useTheme } from '@mui/material/styles';

import { getEnv } from 'mobx-state-tree';
import { IStoresEnv } from '@core/storesEnv';
import { useUserProfileUIStore } from '@core/useStores';
import { useCompanyUIStore } from '@core/useStores';
import { Observer } from 'mobx-react';
import logoCropped from '@assets/logoCropped.svg';
import { flex } from '@styles/resources/mixins';

const useStyles = createUseStyles((theme: ThemeProps) => ({
    verticalContainer: {
        ...flex('row', '', 'center'),
        overflow: 'hidden',
        height: '80px',
        [theme.down('mobile')]: {
            height: 56,
        },
        minWidth: 0,
        maxWidth: '100%',
        flexShrink: 1,
        gap: theme.spacing(3),
        [theme.down('desktop')]: {
            gap: theme.spacing(2),
        },
    },
    logo: {
        height: 64,
        minWidth: 64,
        width: 128,
        maxWidth: '100%',
        flexShrink: 0,
        overflow: 'hidden',
        [theme.down('desktop')]: {
            width: 110,
            height: 56,
        },
        [theme.down('tablet')]: {
            width: 88,
            height: 48,
        },
        [theme.down('mobile')]: {
            width: 72,
            height: 36,
            minWidth: 48,
        },
        '& img': {
            height: '100%',
            width: '100%',
            objectFit: 'contain',
        },
    },
    labelContainer: {
        height: '100%',
        alignContent: 'center',
        minWidth: 0,
        flex: 1,
    },
    centeredLabel: {
        alignSelf: 'center',
        textAlign: 'left',
        fontFamily: `${theme.font.primary}`,
        fontSize: 15,
        color: '#ffffff',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '220px',
        [theme.down('desktop')]: {
            maxWidth: '210px',
            fontSize: 14,
        },
        [theme.down('tablet')]: {
            maxWidth: '140px',
            fontSize: 14,
        },
    },
}))

export const CompanyLogo = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const { api } = getEnv<IStoresEnv>(useUserProfileUIStore());
    const { auth } = getEnv(api);

    const companyUIStore = useCompanyUIStore();

    const getLogo = async () => {
        await companyUIStore.getLogo(auth.userProfile.companyId);
    }

    React.useEffect(() =>{
        getLogo();
    })

    return (
        <Observer>
            {() => {
                const decodedImage = atob(companyUIStore.companyLogo ? companyUIStore.companyLogo : '');
                let imageDecoder = 'png';
                if(decodedImage.indexOf('svg') >= 0){
                    imageDecoder = 'svg+xml'
                }

                return(

                    <div className={styles.verticalContainer}>
                        <div className={styles.logo}>
                            <img src={companyUIStore.companyLogo ? `data:image/${imageDecoder};base64,${companyUIStore.companyLogo}` : logoCropped} alt={messages['header.logo.alt']} />
                        </div>
                        {!companyUIStore.hideName &&
                            <div className={styles.labelContainer}>
                                <p className={styles.centeredLabel}>{companyUIStore.companyName ? companyUIStore.companyName : auth.userCompany?.name}</p>
                            </div>
                        }
                    </div>
                )
            }}
        </Observer>
    );
}
